export const ARTICLES_TARGET = 'articles';

export const STARRED_ARTICLE_TARGET = 'starredArticle';

export const ARTICLE_TARGET = 'article';

export const ARTICLE_INTERES_TARGET = 'interestContent';
